import { IImportModel } from '../importer/model';

export const ancillaryTransfersRatesImportDomainSelector = (state: any): IImportModel =>
  state.ancillaryTransfersRatesImport as IImportModel;
